import { createContext } from 'react';

const TranscriptContext = createContext({
  isOpen: false,
  toggleTranscript: () => {},
});

export default TranscriptContext;
